<template>
    <div class="cal__bloc" 
      v-bind:class="{ 'cal__bloc--active': this.$store.state.idCategoryActive === category.idCategory}" 
      v-on:click="updateCategory"
      v-on:mouseenter="updateCategory"
    >
        <div v-if="this.$store.state.device !== 'desktop'" class="cal__bloc_header cal__font_bree">
            <span class="cal__bloc_number">{{ category.idCategory }}</span>
            <span class="cal__bloc_title">{{ category.name }}</span>
        </div>
        <div class="cal__jobs">
            <div class="cal__jobs_container" ref="categoryContainer">
                <div class="cal__job"
                    v-for="job in jobs" 
                    v-bind:key="job.id"
                    v-bind:class="{ 'cal__job--active': job.id == jobIdActive }"
                    v-on:click="updateFocus(job.id)"
                >
                    <div class="cal__job_title">
                        <span v-html="displayTitleBefore(job.titre, job.id)"></span>
                        <span class="cal__job_title_info">
                          <a class="cal__job_title_info_link" v-on:mouseenter="updateJobInfo(job.id)">
                            <span>i</span>
                          </a>
                        </span>
                        <br>
                        <span v-html="displayTitleAfter(job.titre, job.id)"></span>
                    </div>
                    
                    <div class="cal__job_input">
                        <input 
                            type="text" 
                            class="cal__job_nb" 
                            v-bind:jobid="job.id" 
                            v-on:input="updateJob" 
                            v-bind:value="job.nbjours"
                            v-on:blur="normalizeInput(job.id)"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div v-if="hasScrollButton === true"
            class="cal__bloc_scroll" 
            v-on:click="scroll(category.idCategory)" >
            <span></span>
        </div>
    </div>
</template>

<script>

export default {
  props: {
    category: Object
  },
  computed: {
    jobs() {
      return this.$store.getters.jobsInCategory(this.category.idCategory)
    },
    jobIdActive: function(){
      return this.$store.getters.idJobActive
    },
    freeze: function(){
      // v-bind:disabled="freeze === true"
      return this.$store.getters.appIsFreeze
    },
    hasScrollButton: function(){
        var device = this.$store.state.device
        if (device === 'desktop' && this.jobs.length > 6) {
            return true;
        } else if (device === 'tablet' && this.jobs.length > 4) {
            return true;
        } else if (device === 'mobile' && this.jobs.length > 5) {
            return true;
        }
        return false;
    }
  },
  created () {
    this.PLACES = { 1: 2, 2: 2, 3: 3, 4: 2, 5: 2, 6: 2, 7: 1, 8: 3, 9: 4, 
      10: 1, 11: 3, 12: 1, 13: 4, 14: 1, 15: 2, 16: 2, 17: 1, 18: 2, 19: 2,
      20: 2, 21: 2, 22: 2, 23: 2, 24: 4, 25: 2, 32: 3 };
    this.floatRegex = new RegExp('^[0-9]{0,2}(([.])([0-9]?))?$');
  },
  methods: {
    displayTitleBefore(title, jobId) {
      let place = typeof this.PLACES[jobId] !== 'undefined' ? this.PLACES[jobId] : 2
      let wordsHtml = title.trim().split(' ').slice(0, place).map(function(word) {
        return '<span class="cal__job_title_word">' + word + ' </span>'
      })
      return wordsHtml.join(' ')
    },
    displayTitleAfter(title, jobId) {
      let place = typeof this.PLACES[jobId] !== 'undefined' ? this.PLACES[jobId] : 2
      let wordsHtml = title.trim().split(' ').slice(place).map(function(word) {
        return '<span class="cal__job_title_word">' + word + ' </span>'
      })
      return wordsHtml.join(' ')
    },
    updateJob(e) {
      let nbJours = e.target.value.replace(',', '.');
      if (nbJours.length > 1 && nbJours[0] == '0') {
        nbJours = nbJours.substring(1)
      }
      if (!this.floatRegex.test(nbJours)) {
        nbJours = this.$store.getters.jobNb(e.target.attributes.jobid.nodeValue);
        this.$store.commit('SHOW_MODAL', { type: 'saisie' })
        e.target.value = nbJours
      }
      this.$store.commit('UPDATE_NB', { jobid: e.target.attributes.jobid.nodeValue, nbjours: nbJours})
    },
    updateCategory(){
      this.$store.commit('UPDATE_CATEGORY_ACTIVE', { categoryid: this.category.idCategory })
    }, 
    /*updateJobActive(jobId) {
      this.$store.commit('UPDATE_JOB_ACTIVE', { jobid: jobId })
    },*/
    updateJobInfo(jobId) {
      this.$store.commit('UPDATE_JOB_ACTIVE', { jobid: jobId })
      this.$store.commit('UPDATE_JOB_INFO', { jobid: jobId })
    },
    updateFocus(jobId) {
        var input = document.querySelectorAll('.cal__job_nb[jobid="' + jobId + '"]')[0]
        input.focus()
        if (this.$store.getters.jobNb(jobId) === 0) {
            this.$store.commit('UPDATE_NB', { jobid: jobId, nbjours: ''})
        }
    },
    normalizeInput(jobId) {
        if (this.$store.getters.jobNb(jobId) === '') {
            this.$store.commit('UPDATE_NB', { jobid: jobId, nbjours: 0})
        }
    },
    scroll(){
        let containerRef = 'categoryContainer'
        let device = this.$store.state.device
        let delta = device === 'mobile' ? 54 : device === 'tablet' ? 49 : 58
        let topPos = this.$refs[containerRef].scrollTop;
        this.$refs[containerRef].scrollTop = topPos + delta;
    }
  }
}

</script>
